

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { config } from '@/config/config';
import { BusinessLocation } from '../models/businessLocation';
import { ConfigLocation } from '../models/configLocation';
import Toast from '@/shared/services/toast';
import { googleMyBusinessApi } from '@/features/apps/googlebm/services/googleMyBusinessApi';
@Component({})
export default class GoogleBmLocations extends Vue {
	@Prop() public value: ConfigLocation[];

	public locations: ConfigLocation[] = [];

	public selectedLocations: ConfigLocation[] = [];

	public isLoggedIn: boolean = false;

	public scriptElement: HTMLScriptElement;

	public clientIdMetaElement: HTMLMetaElement;

	public signinScopeMetaElement: HTMLMetaElement;

	@Watch('value', { immediate: true })
	public handleValueChange() {
		if (!this.value) {
			return;
		}

		this.selectedLocations = this.value;
		if (!this.isLoggedIn) {
			this.locations = JSON.parse(JSON.stringify(this.value));
		}
	}

	public async mounted() {
		try {
			this.insertGoogleMetaTags();
			await this.insertGoogleScript();
			gapi.signin2.render('google-signin-button', {
				onsuccess: this.onSignIn,
				theme: 'dark',
				width: 240,
				height: 46,
				longtitle: true
			});
		} catch (e) {
			Toast.showError(`Google script failed to load: ${e.message}`);
		}
	}

	public beforeDestroy() {
		this.removeGoogleScript();
		this.removeGoogleMetaTags();
		if (this.isLoggedIn) {
			this.signOut();
		}
	}

	public removeGoogleMetaTags() {
		if (this.clientIdMetaElement) {
			this.clientIdMetaElement.remove();
		}
		if (this.signinScopeMetaElement) {
			this.signinScopeMetaElement.remove();
		}
	}

	public removeGoogleScript() {
		if (this.scriptElement) {
			this.scriptElement.remove();
		}
	}

	public async onSignIn(googleUser: any) {
		try {
			this.isLoggedIn = true;
			const profile = googleUser.getBasicProfile();
			const googleAccessToken = googleUser.getAuthResponse().access_token;
			const locations = await googleMyBusinessApi.getLocations(googleAccessToken, profile.getId());
			const locationsWithAPlace = locations.filter((location: BusinessLocation) => location.metadata.placeId);
			this.mergeLocations(locationsWithAPlace);
		} catch (e) {
			Toast.showError(`Failed to load locations ${e.message}`);
		}
	}

	public handleCheckboxChange(location: ConfigLocation, checked: boolean) {
		if (checked) {
			this.selectedLocations.push(location);
		} else {
			this.selectedLocations = this.selectedLocations.filter(e => e.placeId !== location.placeId);
		}
		this.$emit('change', this.selectedLocations);
	}

	public isLocationSelected(location: ConfigLocation) {
		if (!this.selectedLocations) {
			return false;
		}
		return this.selectedLocations.find(l => l.placeId === location.placeId) !== undefined;
	}

	public isLocationSaved(location: ConfigLocation) {
		if (!this.selectedLocations || this.selectedLocations.length === 0 || !location.id) {
			return false;
		}
		return this.selectedLocations.find(l => l.id === location.id) !== undefined;
	}

	private mergeLocations(locationsWithAPlace: BusinessLocation[]) {
		for (const location of locationsWithAPlace) {
			const existingLocation = this.locations.find(e => e.placeId === location.metadata.placeId);
			if (!existingLocation) {
				this.locations.push({ placeId: location.metadata.placeId, displayName: location.title } as ConfigLocation);
			}
		}
		this.locations = this.locations.filter(location => locationsWithAPlace.find(s => location.placeId === s.metadata.placeId));
		this.selectedLocations = this.selectedLocations.filter(location => locationsWithAPlace.find(s => location.placeId === s.metadata.placeId));
	}

	private insertGoogleScript() {
		return new Promise((resolve, reject) => {
			this.scriptElement = document.createElement('script');
			this.scriptElement.src = 'https://apis.google.com/js/platform.js';
			this.scriptElement.addEventListener('load', resolve);
			this.scriptElement.addEventListener('error', e => reject(e.error));
			document.head.appendChild(this.scriptElement);
		});
	}

	private insertGoogleMetaTags() {
		this.clientIdMetaElement = document.createElement('meta');
		this.clientIdMetaElement.setAttribute('name', 'google-signin-client_id');
		this.clientIdMetaElement.content = `${config().googleClientId}`;
		document.head.appendChild(this.clientIdMetaElement);

		this.signinScopeMetaElement = document.createElement('meta');
		this.signinScopeMetaElement.setAttribute('name', 'google-signin-scope');
		this.signinScopeMetaElement.content = 'profile email https://www.googleapis.com/auth/business.manage';
		document.head.appendChild(this.signinScopeMetaElement);
	}

	private signOut() {
		gapi.auth2.getAuthInstance().disconnect();
	}

}
